import OrderReviewService from '@/services/Order'
export const state = () => ({
  order: {},
  orders: {
    data: [],
    current_page: 1,
    last_page: 1,
    total: 0
  },
  orderID: null,
  allOrder: [],
  orderReadyPickUp: [],
  orderReviews: {},
  orderDetailPayment: {},
  orderTracking: [],
  suggestions: [],
  orderSummary: {
    'menunggu-pembayaran': 0,
    diproses: 0,
    'pesanan-telah-dikirim': 0,
    'pesanan-siap-diambil': 0,
    'transaksi-selesai': 0,
    'transaksi-dibatalkan': 0
  },
  productOrder: {},
  onSuccess: false,
  orderPayload: {},
  customUUID: ''
})

export const mutations = {
  setOrderReviews (state, payload) {
    const { data } = payload
    if (payload.current_page === 1) {
      state.orderReviews = payload
    } else {
      state.orderReviews.data = state.orderReviews.data.concat(data)
    }
  },
  setOrders (state, payload) {
    if (payload.current_page > 1) {
      state.orders = {
        ...payload,
        data: [...state.orders.data, ...payload.data]
      }
    } else {
      state.orders = payload
    }
  },
  setOrderSummary (state, payload) {
    state.orderSummary = payload
  },
  setDetailOrder (state, payload) {
    state.order = payload
  },
  setDetailOrderPayment (state, payload) {
    state.orderDetailPayment = payload
  },
  setTrackingOrder (state, payload) {
    state.orderTracking = payload
  },
  setOnSuccess (state, payload) {
    state.onSuccess = true
    state.order = payload
  },
  setReviewSuggestions (state, payload) {
    state.suggestions = payload
  },
  setProductOrder (state, payload) {
    state.productOrder = payload
  },
  resetTracking (state) {
    state.orderTracking = []
  },
  resetOrder (state, payload) {
    state[payload] = []
  },
  setOrder (state, payload) {
    state.order = payload
  },
  setOrderID (state, payload) {
    state.orderID = payload
  },
  setOrderPayload (state, payload) {
    state.orderPayload = payload
  },
  setCustomUUID (state, payload) {
    state.customUUID = payload
  }
}

export const actions = {
  getMyOrderReviews ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      OrderReviewService.getMyOrderReviews(
        {
          loggedIn: this.$auth.loggedIn,
          value: this.$auth.loggedIn
            ? this.$auth.getToken(this.$auth.strategy.name)
            : this.$cookies.get('session_id') || ''
        },
        payload
      )
        .then((response) => {
          const commitPayload = {
            ...response.data.data.reviews
          }
          commit('setOrderReviews', commitPayload)
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  getOrders ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      OrderReviewService.getOrders(
        {
          loggedIn: this.$auth.loggedIn,
          value: this.$auth.loggedIn
            ? this.$auth.getToken(this.$auth.strategy.name)
            : this.$cookies.get('session_id') || ''
        },
        payload
      )
        .then((response) => {
          if (response.status === 200) {
            commit('setOrders', response.data.data.orders)
          }
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  getOrderSummary ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      OrderReviewService.getOrderSummary(
        {
          loggedIn: this.$auth.loggedIn,
          value: this.$auth.loggedIn
            ? this.$auth.getToken(this.$auth.strategy.name)
            : this.$cookies.get('session_id') || ''
        },
        payload
      )
        .then((response) => {
          if (response.status === 200) {
            commit('setOrderSummary', response.data.data.order_summary)
          }
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  getDetailOrder ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      OrderReviewService.getDetailOrder(
        {
          loggedIn: this.$auth.loggedIn,
          value: this.$auth.loggedIn
            ? this.$auth.getToken(this.$auth.strategy.name)
            : this.$cookies.get('session_id') || ''
        },
        payload
      )
        .then((response) => {
          if (response.status === 200) {
            commit('setDetailOrder', response.data.data.order)
          }
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  addOrder ({ state }, payload) {
    return new Promise((resolve, reject) => {
      OrderReviewService.addOrder(
        {
          loggedIn: this.$auth.loggedIn,
          value: this.$auth.loggedIn
            ? this.$auth.getToken(this.$auth.strategy.name)
            : this.$cookies.get('session_id') || ''
        },
        payload,
        {
          'Channel-Id': state.customUUID
        }
      )
        .then(resolve)
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  addReview ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      OrderReviewService.addReview(
        {
          loggedIn: this.$auth.loggedIn,
          value: this.$auth.loggedIn
            ? this.$auth.getToken(this.$auth.strategy.name)
            : this.$cookies.get('session_id') || ''
        },
        payload
      )
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  getOrderPaymentDetail ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      OrderReviewService.getOrderPaymentDetail(
        {
          loggedIn: this.$auth.loggedIn,
          value: this.$auth.loggedIn
            ? this.$auth.getToken(this.$auth.strategy.name)
            : this.$cookies.get('session_id') || ''
        },
        payload
      )
        .then((response) => {
          if (response.status === 200) {
            commit('setDetailOrderPayment', response.data.data.order_payment)
          }
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  getTrackingOrder ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      OrderReviewService.getTrackingOrder(
        {
          loggedIn: this.$auth.loggedIn,
          value: this.$auth.loggedIn
            ? this.$auth.getToken(this.$auth.strategy.name)
            : this.$cookies.get('session_id') || ''
        },
        payload
      )
        .then((response) => {
          if (response.status === 200) {
            commit('setTrackingOrder', response.data.data.rajaongkir)
          }
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  getReviewSuggestions ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      OrderReviewService.getReviewSuggestions(
        {
          loggedIn: this.$auth.loggedIn,
          value: this.$auth.loggedIn
            ? this.$auth.getToken(this.$auth.strategy.name)
            : this.$cookies.get('session_id') || ''
        },
        payload
      )
        .then((response) => {
          if (response.status === 200) {
            commit(
              'setReviewSuggestions',
              response.data.data.review_suggestions
            )
          }
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  getOrderProductDetail ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      OrderReviewService.getOrderProductDetail(
        {
          loggedIn: this.$auth.loggedIn,
          value: this.$auth.loggedIn
            ? this.$auth.getToken(this.$auth.strategy.name)
            : this.$cookies.get('session_id') || ''
        },
        payload
      )
        .then((response) => {
          if (response.status === 200) {
            commit('setProductOrder', response.data.data.order_product)
          }
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  editStatus ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      OrderReviewService.editStatus(
        {
          loggedIn: this.$auth.loggedIn,
          value: this.$auth.loggedIn
            ? this.$auth.getToken(this.$auth.strategy.name)
            : this.$cookies.get('session_id') || ''
        },
        payload.id,
        payload.payload
      )
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  postPaymentConfirmation ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      OrderReviewService.postPaymentConfirmation(
        {
          loggedIn: this.$auth.loggedIn,
          value: this.$auth.loggedIn
            ? this.$auth.getToken(this.$auth.strategy.name)
            : this.$cookies.get('session_id') || ''
        },
        payload.id,
        payload.payload
      )
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  downloadInvoice ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      OrderReviewService.downloadInvoice(
        {
          loggedIn: this.$auth.loggedIn,
          value: this.$auth.loggedIn
            ? this.$auth.getToken(this.$auth.strategy.name)
            : this.$cookies.get('session_id') || ''
        },
        payload
      )
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  cancelOrder ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      OrderReviewService.cancelOrder(
        {
          loggedIn: this.$auth.loggedIn,
          value: this.$auth.loggedIn
            ? this.$auth.getToken(this.$auth.strategy.name)
            : this.$cookies.get('session_id') || ''
        },
        payload.id,
        payload.payload
      )
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  checkReorder ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      OrderReviewService.checkReorder(
        {
          loggedIn: this.$auth.loggedIn,
          value: this.$auth.loggedIn
            ? this.$auth.getToken(this.$auth.strategy.name)
            : this.$cookies.get('session_id') || ''
        },
        payload
      )
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  }
}
